import BaseList from 'records/BaseList';
import { List } from 'immutable';
import {AssetTransferStats} from 'records/AssetTransferStat';

import {
  ASSET_TRANSFER_STATS_ASYNC_ACTION_START,
  ASSET_TRANSFER_STATS_ASYNC_ACTION_ERROR,
  ASSET_TRANSFER_STATS_ASYNC_UPDATE_SUCCESS,
  ASSET_TRANSFER_STATS_UPDATE_SUCCESS,
  ASSET_TRANSFER_STATS_RESET_STATE,
} from 'actions/assetTransferStats';


const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [ASSET_TRANSFER_STATS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [ASSET_TRANSFER_STATS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [ASSET_TRANSFER_STATS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const assetTransferStats = AssetTransferStats(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: assetTransferStats,
    });
  },
  [ASSET_TRANSFER_STATS_UPDATE_SUCCESS]: (state, action) => {
    return state.mergeDeep({
      data: action.data,
    });
  },
  [ASSET_TRANSFER_STATS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function assetTransferStat(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
